module.exports = __webpack_public_path__ + "img/PG.4e87aebf.svg";